<!-- компонент vdsView: просмотр VDS -->
<template>
	<div v-if="this.$store.state.is_auth">
		<template v-if="!form_ErrorMessage">

			<!-- блок с локальным сообщением об ошибке -->
			<transition name="fadeControl" key="transitionError">
				<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
					<button v-show="localErrorMessageButton" @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
					<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessageClear)"></span>
				</div>
			</transition>
			<!-- ===================================== -->

			<!-- таблица DNS-записей -->
			<Table
				crud="dns-records"
				:access="Access"
				:url-list="tableUrlList"
				:url-create="tableUrlCreate"
				:columns="tableColumns"
				@error="getError"
				id-columns="dns_id" />
			<!-- ===================================== -->

		</template>
		<errorAlert v-else :message="form_ErrorMessage" />
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
import Table from '@/components/elements/table'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'domainView',
	//=========================================================================
	// внутренние свойства компонента
	//=========================================================================
	data() {
		return {
			// наименование CRUD
			crud: 'dns',

			// ID ssl
			id: null,

			// локальное сообщение об ошибке
			localErrorMessage: '',

			// кешированные данные для просмотра
			Data: null,

			// колонки для таблицы DNS-записей
			tableColumns: {
				'dns_host': {
					style: 'width: 220px'
				},
				'dns_type': {
					style: 'width: 60px'
				},
				'dns_priority': {
					style: 'width: 30px'
				},
				'dns_value': {},
				'dns_timestamp': {
					style: 'width: 105px',
					formatter: (value) => this.formater_StrDateFormat(value)
				}
			}
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// если ли доступ к редактированию
		Access() {
			// если есть процесс - сразу закрываем доступ
			if (this.Data &&
				this.Data.service &&
				this.Data['service']['service_status'] &&
				this.Data['service']['service_status']['text'] &&
				String(this.Data['service']['service_status']['text']).length)
				return false
			// иначе - права по умолчанию
			return this.isAccess('service/update')
		},
		localErrorMessageClear() {
			if (this.localErrorMessage === undefined ||
				this.localErrorMessage === null ||
				this.localErrorMessage === '')
				return ''
			if (this.localErrorMessage.charAt(0) === 'x') return this.localErrorMessage.substr(1)
			return this.localErrorMessage
		},
		localErrorMessageButton() {
			if (this.localErrorMessage === undefined ||
				this.localErrorMessage === null ||
				this.localErrorMessage === '')
				return false
			if (this.localErrorMessage.charAt(0) === 'x') return false
			return true
		},
		tableUrlList() {
			return this.id ? '/dns/list?service_id=' + this.id : null
		},
		tableUrlCreate() {
			return this.id ? '/dns-records/create/' + this.id : null
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// получим ID dns
		this.id = this.$route.params['id']
		if (this.id)
		{
			// запомним ID текущего домена
			this.$store.commit('domainRecordId', this.id)
			// теперь можно запросить данные
			this.requestData()
		}
		else
		{
			// ошибка
			this.localErrorMessage = this.localeFtc('main/unknown_page')
			// сброс ID домена в Vuex
			this.$store.commit('domainRecordId', null)
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных для просмотра
		//---------------------------------------------------------------------
		requestData() {
			// еще раз проверим ID
			if (!this.id)
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// теперь точно можно делать запрос
			this.$http.get(this.APIServerUrl + '/service/view/' + this.id).then(
				// успешный ответ
				respons => {
					// получаем ответ
					let _dt = respons && respons.data && typeof respons.data === 'object' ? respons.data : false

					// ответ корректный
					if (_dt && _dt['status'] === 'ok')
					{
						// запоминаем данные
						this.Data = _dt
						// на этом все
						return
					}

					// другая ошибка
					this.localErrorMessage = this.formatRequestError(respons)
				},
				// отрицательный ответ
				respons => {
					// ошибка ответа сервера
					this.localErrorMessage = this.formatRequestError(respons)
				}
			)
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== this.getRealCrud(this.crud)) return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// обновляем данные, пришедшие с сервера
			if (String(_id) === String(this.id)) this.requestData()
		},
		//---------------------------------------------------------------------
		// установка успешного сообщения
		//---------------------------------------------------------------------
		setLocalSuccessMessage(msg) {
			EventBus.$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			})
		},
		//---------------------------------------------------------------------
		// если пришла ошибки от потомка
		//---------------------------------------------------------------------
		getError(msg) {
			this.localErrorMessage = msg
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Table
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.ssl-info-block {	
	padding-top: 0;
	line-height: 2;
	font-size: 95%;
}

.ssl-info-block > p {
	margin: 10px 0;
	width: 70%;
	font-size: 12px;
	font-weight: 300;
	line-height: 1.4;
}

.ssl-info-span {
	font-weight: 500;
}

.certificate-add-info-block {
	margin: 15px 0;
}

.upper-hint {
	display: table-cell;
    vertical-align: middle;
    font-weight: 300;
    font-size: 13px;
}

.ssl-info-table {
	margin-top: 10px;
	margin-bottom: 20px;
	border: 1px solid #eee;
	border-radius: 4px;
	padding: 10px 15px;
}

.ssl-info-table-row {
	display: table;
	margin: 10px 0;
}

.ssl-info-table-row:first-child {
	margin-top: 5px;
}
.ssl-info-table-row:last-child {
	margin-bottom: 5px;
}

.ssl-info-table-row .header {
	display: table-cell;
	width: 120px;
	line-height: 1.2;
}

.ssl-info-table-row .value {
	display: table-cell;
	font-weight: 500;
	line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// domainView.vue?1b4f56d9